import React, { useCallback, useEffect, useReducer, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import ReactSelect, { components } from "react-select";
import AsyncSelect from "react-select/async";
import Button from "./Button";
import * as commonData from "../../Common";
import { useParams } from "react-router-dom";
import Loading from "./Loading";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import RModal from "react-bootstrap/Modal";
import CustomOption from "../CustomOption";
//import "rsuite/CheckPicker/styles/index.css";
import CheckPicker from "rsuite/CheckPicker";
import SelectPicker from "rsuite/SelectPicker";
import { DateRangePicker } from "rsuite";
//import ReactMultiSelectCustom from "./../multiselectcustom/ReactMultiSelectCustomSearch";

const AdvancedFilter = ({
  //  children,
  show,
  onClose,
  title,
  advfilterSubmit,
  isAdvFilterCreate,
  advfilterToShow,
  //  createFilterByView,
  values,
  isEdit,
  //  isKanban,
  //  type,
}) => {
  const params = useParams();
  const apiUrl = commonData.commonData().apiUrl;
  const advFilter_default = [
    {
      field_name: "",
      comparison: "",
      field_value: "",
      comparison_type: "default",
    },
  ];
  const [state, setState] = useState({
    columns: [],
    attributeList: [],
    users: [],
    initialBlocks: isEdit
      ? JSON.parse(values.filter_value)
      : advfilterToShow && advfilterToShow.length > 0
      ? advfilterToShow
      : advFilter_default,
    advancedFieldType: {},
    saved_values: [],
    loading: false,
  });
  const [apiData, setApiData] = useState({});
  const comparison_options_new = {
    text: [
      { label: "Contains", value: "contains" },
      { label: "Does not contains", value: "does_not_conatains" },
    ],
    date: [
      { label: "Equals", value: "equals" },
      { label: "Not Equals", value: "not_equals" },
      { label: "Greater Than", value: "greater_than" },
      { label: "Less Than", value: "less_than" },
      { label: "Greater Than Or Equal", value: "greater_than_or_equal" },
      { label: "Less Than Or Equal", value: "less_than_or_equal" },
    ],
    default: [
      { label: "Equals", value: "equals" },
      { label: "Not Equals", value: "not_equals" },
    ],
  };

  useEffect(() => {
    (async () => {
      const resp = await fetch(`${apiUrl}tattle/attributes`, {
        method: "POST",
        body: JSON.stringify({
          app_token: commonData.getCommonData().app_token,
          attribute_set_key: params.attribute_set_key,
          attribute_status: true,
        }),
      });

      const resdata = await resp.json();
      console.log("attr", resdata);
      if (resdata.code === 200) {
        let attributeList = resdata.data.map((item) => ({
          label: item.headerName,
          value: item.field,
        }));
        setState((state) => {
          return {
            ...state,
            columns: resdata?.data,
            attributeList,
          };
        });

        resdata.data.map((item) => {
          console.log(98, item.field, item.attribute_type);
          if (
            item.field === "assign_to" ||
            item.field === "monitoring" ||
            item.field === "reporter" ||
            item.field === "people"
          ) {
            callPeopleUrls(item.api_url, item.field);
          } else {
            if (
              item.attribute_type === "api" ||
              item.attribute_type === "release" ||
              item.attribute_type === "customer_type" ||
              item.attribute_type === "company_name" ||
              item.attribute_type === "product" ||
              item.attribute_type === "account_manager" ||
              item.attribute_type === "tse_owner" ||
              item.attribute_type === "sales_manager"
            ) {
              callApiUrls(item.api_url, item.field, item.attribute_type);
            }
          }
        });
      }
    })();
  }, []);

  function removeCondition(e, key_to_remove) {
    state.initialBlocks.splice(key_to_remove, 1);
    setState((state) => {
      return {
        ...state,
        initialBlocks: state.initialBlocks,
      };
    });
  }

  const handleApply = (range, key, field, field_type) => {
    console.log(291, range);
    if (range !== null) {
      const date_select = [
        convertDateFormat(range[0]),
        convertDateFormat(range[1]),
      ];
      addKeyAndValue(state.initialBlocks, key, field, date_select);
    } else {
      var initialBlocks = state.initialBlocks;
      initialBlocks[key]["field_value"] = null;
      setState((state) => {
        return {
          ...state,
          initialBlocks: initialBlocks,
        };
      });
    }
  };

  const callPeopleUrls = async (api_url, field) => {
    const response = await fetch(`${api_url}`);
    const rdata = await response.json();
    const newdata = Object.entries(rdata).map(([key, val]) => {
      return (
        val.is_active == 1 && {
          ...val,
          label: val.name,
          value: val.user_uuid,
        }
      );
    });

    setState((state) => {
      return {
        ...state,
        users: newdata,
      };
    });
  };

  const callApiUrls = async (api_url, field, type=false, search=false) => {
    //        if (apiData[field]) {
    //          return apiData[field].filter((item) =>
    //            item.label.toLowerCase().includes(evt.toLowerCase())
    //          );
    //        }
    let response;
    if (type === "company_name") {

      // Set company_name in requestBody from initialBlocks where field_name === type
      const companyField = state.initialBlocks.find(
        (block) => block.field_name === type
      );

      const requestBody = {
        search: search || "",
        company_name: companyField ? companyField.field_value : [],
      };
      response = await fetch(api_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
    } else {
      response = await fetch(`${api_url}`);
    }

    // const response = await fetch(`${api_url}`);
    const rdata = await response.json();
    if (field === "product") {
      let apidata = rdata.map((item) => ({
        label: item.value,
        value: item.id,
      }));
      setApiData((state) => {
        return {
          ...state,
          [field]: apidata,
        };
      });
    } else if (field === "customer_type") {
      let customertypedata = Object.keys(rdata).map((ke) => ({
        label: rdata[ke].customer_type,
        value: ke,
      }));
      setApiData((state) => {
        return {
          ...state,
          [field]: customertypedata,
        };
      });
    } else if (field === "company_name") {
      const { data } = rdata;

      let companynamedata = data.map((ite) => ({
        label: ite.value,
        value: ite.id,
      }));

      setApiData((state) => {
        return {
          ...state,
          [field]: companynamedata,
        };
      });
    } else if (field === "project") {
      const project = rdata?.data?.map((ite) => ({
        label: ite.title,
        value: ite.customer_tattle_uuid,
        url: ite.url,
      }));

      setApiData((state) => {
        return {
          ...state,
          [field]: project,
        };
      });
    } else if (
      field === "account_manager" ||
      field === "tse_owner" ||
      field === "sales_manager"
    ) {
      const mgr = rdata?.data?.map((ite) => ({
        label: ite.name,
        value: ite.user_uuid,
      }));

      setApiData((state) => {
        return {
          ...state,
          [field]: mgr,
        };
      });
    } else if (field === "release") {
      const mgr = rdata?.map((ite) => ({
        label: ite.value,
        value: ite.id,
      }));
      console.log(229, mgr);
      setApiData((state) => {
        return {
          ...state,
          [field]: mgr,
        };
      });
    } else {
      var final_res = true;
      if (rdata.hasOwnProperty("code")) {
        final_res = false;
      }
      if (final_res) {
        console.log("final_res", field, rdata);
        if (typeof rdata === "object") {
          let apidata = rdata.map((item) => ({
            label: item.value,
            value: item.id,
          }));
          setApiData((state) => {
            return {
              ...state,
              [field]: apidata,
            };
          });
        } else {
          if (field.includes("effort")) {
            let apidata = Object.keys(rdata).map((ke) => ({
              label: ke.name,
              value: ke.total_hours,
            }));
            setApiData((state) => {
              return {
                ...state,
                [field]: apidata,
              };
            });
          }
        }
      }
    }
  };

  function addMoreFilter() {
    var validateForm = validateFilterForm();
    console.log(579, validateForm);
    if (validateForm) {
      var keyRes_init = Array(1).fill({
        field_name: "",
        comparison: "",
        field_value: "",
        comparison_type: "default",
      });
      var resultant_arr = [...state.initialBlocks, ...keyRes_init];
      //add more part for keyresult block
      setTimeout(() => {
        setState((state) => {
          return {
            ...state,
            initialBlocks: resultant_arr,
          };
        });
      }, 500);
    }
  }

  function getFieldType(data, key, params_key) {
    var initialBlocks = state.initialBlocks;
    initialBlocks[key][params_key] = data ? data : "";
    if (data !== null) {
      if (initialBlocks[key].hasOwnProperty("errors")) {
        initialBlocks[key]["errors"][params_key] = "";
      }
      const transformCustomFilter = state.columns.filter(
        (item) => item.field === data
      );
      var comparison_type = transformCustomFilter[0].attribute_type;
      var attribute_key = transformCustomFilter[0].field;
      if (
        comparison_type === "text" ||
        comparison_type === "textarea" ||
        comparison_type === "name"
      ) {
        comparison_type = "text";
      } else if (
        attribute_key === "release" ||
        comparison_type === "timestamp" ||
        comparison_type === "number" ||
        comparison_type === "effort" ||
        comparison_type === "date" ||
        comparison_type === "start_date" ||
        comparison_type === "end_date" ||
        comparison_type === "go_live_date"
      ) {
        comparison_type = "date";
      } else {
        comparison_type = "default";
      }
      initialBlocks[key]["comparison_type"] = comparison_type;
      initialBlocks[key]["comparison"] =
        comparison_options_new[comparison_type][0].value;
    }
    setState((state) => {
      return {
        ...state,
        initialBlocks: initialBlocks, //,advancedFilter
      };
    });
  }

  function showRelatedComparison(key, attribute_type) {
    if (attribute_type) {
      if (isEdit) {
        attribute_type = state.initialBlocks[key].comparison_type;
      } else {
        if (!["text", "date"].includes(attribute_type)) {
          attribute_type = "default";
        }
      }
      return (
        <SelectPicker
          className={
            state.initialBlocks[key].hasOwnProperty("errors")
              ? state.initialBlocks[key].errors.comparison
              : ""
          }
          style={{ width: "100%" }}
          menuStyle={{ zIndex: 1100 }}
          data={
            (comparison_options_new &&
              comparison_options_new[attribute_type]) ||
            []
          }
          onChange={(evt) => handleAdvFilterReactSelect(evt, key, "comparison")}
          value={
            (state.initialBlocks && state.initialBlocks[key].comparison) ||
            comparison_options_new[attribute_type][0].value
          }
          searchable={false}
        />
      );
    }
  }

  function showRelatedFieldType(key, field_type, filter_data) {
    //        var filter_data = state.initialBlocks;
    if (field_type) {
      if (state.columns.length > 0) {
        var selectedData =
          state.columns[
            state.columns
              .map(function (it) {
                return it.field;
              })
              .indexOf(field_type)
          ];
        if (selectedData.hasOwnProperty("attribute_type")) {
          if (
            selectedData.attribute_type === "assign_to" ||
            selectedData.attribute_type === "monitoring" ||
            selectedData.attribute_type === "reporter" ||
            selectedData.attribute_type === "people"
          ) {
            return (
              <div className="form-group mb-1">
                <CheckPicker
                  className={
                    filter_data[key].hasOwnProperty("errors")
                      ? filter_data[key].errors.field_value
                      : ""
                  }
                  style={{ width: "100%" }}
                  menuStyle={{ zIndex: 1100, height: "200px" }}
                  data={state.users && state.users}
                  value={
                    (state.initialBlocks &&
                      state.initialBlocks[key].field_value) ||
                    []
                  }
                  onChange={(evt) =>
                    handleAdvFilterReactSelect(evt, key, "field_value")
                  }
                />
              </div>
            );
          } else if (
            selectedData.attribute_type === "api" ||
            selectedData.attribute_type === "release" ||
            selectedData.attribute_type === "product" ||
            selectedData.attribute_type === "company_name" ||
            selectedData.attribute_type === "customer_type" ||
            selectedData.attribute_type === "account_manager" ||
            selectedData.attribute_type === "tse_owner" ||
            selectedData.attribute_type === "sales_manager"
          ) {
            return (
              <div className="form-group mb-1">
                <CheckPicker
                  className={
                    filter_data[key].hasOwnProperty("errors")
                      ? filter_data[key].errors.field_value
                      : ""
                  }
                  style={{ width: "100%" }}
                  menuStyle={{ zIndex: 1100, height: "300px" }}
                  data={apiData?.[field_type]}
                  value={
                    (state.initialBlocks &&
                      state.initialBlocks[key].field_value) ||
                    []
                  }
                  onSearch={(search) => {
                    if (search) {
                      
                        if (window.advFilterApiTimeout) {
                        clearTimeout(window.advFilterApiTimeout);
                        }
                        window.advFilterApiTimeout = setTimeout(() => {
                        callApiUrls(
                          selectedData.api_url,
                          selectedData.attribute_type,
                          selectedData.attribute_type,
                          search
                        );
                        }, 1000);
                    } else {
                      callApiUrls(
                        selectedData.api_url,
                        selectedData.attribute_type,
                        selectedData.attribute_type,
                      );
                    }
                  }}
                  onChange={(evt) =>
                    handleAdvFilterReactSelect(evt, key, "field_value")
                  }
                />
              </div>
            );
          } else if (
            selectedData.attribute_type === "select" ||
            selectedData.attribute_type === "status" ||
            selectedData.attribute_type === "priority" ||
            selectedData.attribute_type === "category"
          ) {
            let getOptionsSelect = selectedData.options.map((item) => ({
              label:
                field_type === "status" || field_type === "category"
                  ? item.name
                  : item.option_name,
              value: item._id,
            }));
            return (
              <div className="form-group mb-1">
                <CheckPicker
                  className={
                    filter_data[key].hasOwnProperty("errors")
                      ? filter_data[key].errors.field_value
                      : ""
                  }
                  style={{ width: "100%" }}
                  menuStyle={{ zIndex: 1100 }}
                  data={getOptionsSelect}
                  value={
                    (state.initialBlocks &&
                      state.initialBlocks[key].field_value) ||
                    []
                  }
                  onChange={(evt) =>
                    handleAdvFilterReactSelect(evt, key, "field_value")
                  }
                />
              </div>
            );
          } else if (
            selectedData.attribute_type === "date" ||
            selectedData.attribute_type === "start_date" ||
            selectedData.attribute_type === "end_date"
          ) {
            let edit_date;
            if (state.initialBlocks && state.initialBlocks[key].field_value) {
              let newval = state.initialBlocks[key].field_value;
              edit_date = [new Date(newval[0]), new Date(newval[1])];
            }
            return (
              <div className="form-group mb-1">
                <DateRangePicker
                  menuStyle={{
                    zIndex: 1100,
                    height: "290px",
                    overflow: "auto",
                  }}
                  showOneCalendar
                  editable={false}
                  className={
                    filter_data[key].hasOwnProperty("errors")
                      ? filter_data[key].errors.field_value
                      : ""
                  }
                  onChange={(evt) =>
                    handleApply(evt, key, "field_value", field_type)
                  }
                  value={edit_date || null}
                />
              </div>
            );
          } else {
            return (
              <div className="form-group mb-1">
                <input
                  type="text"
                  name="field_value"
                  className={
                    "field-val-txt " +
                    (filter_data[key].hasOwnProperty("errors")
                      ? filter_data[key].errors.field_value
                      : "")
                  }
                  onChange={(evt) =>
                    handleAdvFilterReactSelect(evt, key, "field_value")
                  }
                  value={filter_data[key].field_value}
                  autocomplete="off"
                />
              </div>
            );
          }
        }
      }
    } else {
      return (
        <div className="form-group mb-1">
          <input
            type="text"
            name="field_value"
            className={
              "field-val-txt " +
              (filter_data[key].hasOwnProperty("errors")
                ? filter_data[key].errors.field_value
                : "")
            }
            onChange={(evt) =>
              handleAdvFilterReactSelect(evt, key, "field_value")
            }
            value={filter_data[key].field_value}
            autocomplete="off"
          />
        </div>
      );
    }
  }

  const addKeyAndValue = (arr, index, field, field_val) => {
    var initial_block_errors = state.initialBlocks;
    for (let i = 0; i < arr.length; i++) {
      if (field_val !== "") {
        if (
          initial_block_errors[index] &&
          initial_block_errors[index].hasOwnProperty("errors")
        ) {
          initial_block_errors[index].errors[field] = "";
        }
      }
      initial_block_errors[index][field] = field_val;
    }
    setState((state) => {
      return {
        ...state,
        //            advancedFilter: arr,
        initialBlocks: initial_block_errors,
      };
    });
    var validateForm = validateFilterForm();
    //        console.log(673,validateForm)
    if (validateForm) {
      advfilterSubmit({ advance_filter: state.initialBlocks });
    }
  };

  const convertDateFormat = (date) => {
    let convertdate = null;
    if (date) {
      convertdate = moment(date).format("YYYY-MM-DD");
    }
    return convertdate;
  };

  const handleAdvFilterReactSelect = useCallback(
    (evt, key, field, field_type) => {
      if (evt) {
        if (evt.hasOwnProperty("target")) {
          addKeyAndValue(state.initialBlocks, key, field, evt.target.value);
        } else {
          addKeyAndValue(state.initialBlocks, key, field, evt);
        }
      } else {
        addKeyAndValue(state.initialBlocks, key, field, "");
      }
    },
    [state.initialBlocks]
  );

  const validateFilterForm = () => {
    //    var formData = (Object.keys(values).length > 0) ? JSON.parse(values.filter_value ) : state.initialBlocks;
    var formData = state.initialBlocks;
    var formSubmit = true;
    if (formData.length > 0) {
      var error_res = {};
      formData.forEach(function (result, index) {
        console.log(536, result);
        if (result.hasOwnProperty("field_name")) {
          if (result.field_name === "") {
            formData[index].errors = {
              ...formData[index].errors,
              field_name: "select-error",
            };
            formSubmit = false;
          }
        }
        if (result.hasOwnProperty("comparison")) {
          if (result.comparison === "") {
            formData[index].errors = {
              ...formData[index].errors,
              comparison: "select-error",
            };
            formSubmit = false;
          }
        }
        if (result.hasOwnProperty("field_value")) {
          if (result.field_value === "" || result.field_value === "null") {
            formData[index].errors = {
              ...formData[index].errors,
              field_value: "select-txt-error",
            };
            formSubmit = false;
          }
        }
      });
      console.log("column_error", formData);
      setState((state) => {
        return {
          ...state,
          initialBlocks: formData,
        };
      });
    } else {
      formSubmit = false;
    }
    return formSubmit;
  };

  const resetFilter = () => {
    setState((state) => {
      return {
        ...state,
        initialBlocks: advFilter_default,
      };
    });
  };

  const createFilterHandler = () => {
    var validateForm = validateFilterForm();
    if (validateForm) {
      if (isEdit) {
        isAdvFilterCreate(state.initialBlocks, values.filter_id);
      } else {
        isAdvFilterCreate(state.initialBlocks);
      }
    }
  };

  return (
    <RModal
      size="md"
      show={show}
      onHide={onClose}
      centered
      className="edit-Modal"
      enforceFocus={false}
      backdrop={false}
    >
      <RModal.Header closeButton>
        <RModal.Title>{isEdit ? values?.filter_name : title}</RModal.Title>
      </RModal.Header>

      <Form>
        <RModal.Body>
          <div class="bottom-inner-body">
            <div class="child-inner-bottom">
              {state.initialBlocks.map((item, key) => (
                <div
                  id={"keyRes" + key}
                  class={"single-add" + (key > 0 ? " mt20" : "")}
                >
                  <div class="top-area">
                    <div class="filter-row">
                      <div class="filter-column">
                        <div className="form-group mb1">
                          <SelectPicker
                            className={
                              `fldName ` +
                              (item.hasOwnProperty("errors")
                                ? item.errors.field_name
                                : "")
                            }
                            style={{ width: "100%" }}
                            menuStyle={{ zIndex: 1100, height: "200px" }}
                            data={state.attributeList}
                            value={item.field_name ? item.field_name : ""}
                            onChange={(evt) =>
                              getFieldType(evt, key, "field_name")
                            }
                          />
                        </div>
                      </div>
                      <div class="filter-column filter-comp">
                        {showRelatedComparison(key, item.comparison_type)}
                      </div>
                      <div class="filter-column">
                        {showRelatedFieldType(
                          key,
                          item.field_name,
                          state.initialBlocks
                        )}
                      </div>
                      {state.initialBlocks.length > 1 ? (
                        <div class="filter-column delete-filter">
                          <span
                            type="button"
                            onClick={(e) => removeCondition(e, key)}
                            id={`delKeyBtn_${key}`}
                            title="Remove Filter"
                          >
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              stroke-width="0"
                              viewBox="0 0 24 24"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
                              <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
                            </svg>
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              ))}
              {state.initialBlocks[0].field_name !== "" ||
              state.initialBlocks[0].comparison !== "" ||
              state.initialBlocks[0].field_value !== "" ? (
                <button
                  class="add-more"
                  type="button"
                  onClick={(e) => addMoreFilter()}
                >
                  <span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1024_11032)">
                        <path
                          d="M8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 8.00001C14.6668 4.31811 11.6821 1.33334 8.00016 1.33334C4.31826 1.33334 1.3335 4.31811 1.3335 8.00001C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667Z"
                          fill="#006efa"
                          stroke="#006efa"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M8 5.33334V10.6667"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M5.3335 8H10.6668"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </g>
                      <defs>
                        <clipPath id="clip0_1024_11032">
                          <rect width="16" height="16" fill="white"></rect>
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  Add More Filter
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
        </RModal.Body>
        <RModal.Footer>
          <div
            className="col-md-12 float-end"
            style={{ textAlign: "right", marginTop: "12px" }}
          >
            <Button
              text={`Reset`}
              className={`muBtn cancel-btn`}
              type="button"
              onClick={resetFilter}
            />
            <Button
              text={`Apply`}
              className={`muBtn _blue ml-5`}
              type="button"
              onClick={createFilterHandler}
            />
          </div>
        </RModal.Footer>
      </Form>
    </RModal>
  );
};

export default AdvancedFilter;
